import { useEffect, useState } from "react";
import { NotebookPen, ChevronDown } from "lucide-react";
import { api } from "@/lib/api";

const NOTE = /special|notes?|history|remark/i;
const SKIP = /service ?performed|comment/i;

export default function NotesPanel({ source }) {
  const [notes, setNotes] = useState(null);
  const [open, setOpen] = useState(true);

  useEffect(() => {
    setNotes(null);
    if (!source?.record_id) return;
    api.get(`/databases/${source.db_id}/tables/${encodeURIComponent(source.table)}/records/${source.record_id}/related`)
      .then(({ data }) => setNotes(Object.entries(data.record.data).filter(([k, v]) => NOTE.test(k) && !SKIP.test(k) && v)))
      .catch(() => setNotes([]));
  }, [source?.db_id, source?.table, source?.record_id]);

  if (!notes?.length) return null;
  return (
    <div className="mb-4 border border-amber-400/40 bg-amber-400/5 rounded-lg" data-testid="notes-panel">
      <button onClick={() => setOpen(!open)} className="w-full flex items-center justify-between px-4 py-3" data-testid="notes-panel-toggle">
        <span className="flex items-center gap-2 font-display font-bold text-amber-300"><NotebookPen size={16} /> Tech notes from the record</span>
        <ChevronDown size={16} className={`transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="px-4 pb-4 space-y-3 max-h-64 overflow-y-auto">
          {notes.map(([k, v]) => (
            <div key={k}>
              <p className="text-[10px] font-mono uppercase tracking-widest text-muted-foreground">{k}</p>
              <div className="text-sm leading-relaxed space-y-1 mt-1" data-testid={`note-${k.replace(/\s+/g, "-")}`}>
                {String(v).split(/\s+(?=\d{1,2}\/\d{1,2}\/\d{2,4}\s*-)/).map((line, i) => <p key={i}>{line}</p>)}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
